//Import Libraries
import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import { Grid } from "@material-ui/core";
import Autocomplete from "@mui/material/Autocomplete";
import { config } from "../../../config/config";
import { updateSourceInputs, updateAlert } from "../../../redux/actions";
import { InputLabel } from "@material-ui/core";
import "../rociview.scss";
import Loader from "../../../components/Loader/Loader";
import TextField from "@mui/material/TextField";
import { useUserAuthentication } from "../../../utils/utils";
import FileUpload from "../../../components/FileUpload/FileUpload";
import GlobalDropZone from "../../../components/FileUpload/GlobalDropZone";
import Popover from "@mui/material/Popover";
import { useHistory } from "react-router-dom";

let api = config.api.api_url;

function MetaSearchFilters(props) {
  let {
    user,
    updateSourceInputs,
    source_data,
    isFileUploading,
    loading,
    tableLoading,
    setMappedData,
    updateAlert,
    isPlaceholderFetching,
  } = props;
  const [expand, setExpand] = useState(false);
  const [isCountryLoading, setIsCountryLoading] = useState(false);
  const [isSffFileIdLoading, setIsSffFileIdLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { login } = useUserAuthentication();
  let history = useHistory();

  const open = Boolean(anchorEl);

  const isFilterAllVisible = useMemo(() => {
    if (source_data.current_category === "") {
      return true;
    }
    if (isPlaceholderFetching) {
      return source_data.current_filter_value === "Unmapped";
    }
    return false;
  }, [source_data, source_data.current_filter_value, isPlaceholderFetching]);

  const isFilterUnmappedVisible = useMemo(() => {
    if (source_data.current_category === "") {
      return true;
    }
    if (isPlaceholderFetching) {
      return source_data.current_filter_value === "All";
    }
    return false;
  }, [source_data, source_data.current_filter_value, isPlaceholderFetching]);

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  const has_Awaiting_Data = useMemo(() => {
    const data = source_data?.has_awaiting_data;

    if (!data) return false;

    const { has_records, has_access } = data;

    return !has_records || (has_records && has_access);
  }, [source_data.has_awaiting_data]);

  const clearState = () => {
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isFileUploaded", false);
    updateSourceInputs("isNewDataInserted", false);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_filters", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("download_sample_file", []);
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("current_columns", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("approvalData", []);
    updateSourceInputs("approvalTable_Header", []);
  };

  const handleSourceChange = async (e, selectedOption) => {
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("current_dimension", {});
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_source", selectedOption.value);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
  };

  const handleDimensionChange = async (e, selectedOption) => {
    setIsCountryLoading(true);
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_dimension", selectedOption);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);

    const params = new URLSearchParams({
      dataset_name: selectedOption.value || "",
      country: "",
      filter: "country",
    });

    try {
      // code for initial data fetching
      const response = await fetch(
        api + `/attribute_enrichment/getmetafilters?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const responseJson = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (responseJson?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          setIsCountryLoading(false);
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      const { COUNTRY, ...data } = responseJson?.data || [];
      const countryOptions =
        COUNTRY?.filter(
          (country) =>
            country !== null && country !== undefined && country !== "",
        )?.map((country) => ({
          label: country.COUNTRY,
          value: country.COUNTRY_CODE,
        })) ?? [];

      const FINAL_DATA = {
        ...source_data.data,
        dropdown: { ...source_data.data.dropdown, ...data },
      };

      updateSourceInputs("current_mapped_country", countryOptions);
      updateSourceInputs("data", FINAL_DATA);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
      setIsCountryLoading(false);
    } finally {
      setIsCountryLoading(false);
    }
  };

  const handleCountryChange = async (e, selectedOption) => {
    setIsSffFileIdLoading(true);
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_country", selectedOption.label);
    updateSourceInputs("current_country_code", selectedOption.value);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("current_mapped_data", []);

    const params = new URLSearchParams({
      dataset_name: source_data.current_dimension.value || "",
      country: selectedOption.value,
      filter: "file_id",
    });

    try {
      // code for initial data fetching
      const response = await fetch(
        api + `/attribute_enrichment/getmetafilters?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const responseJson = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (responseJson?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          setIsSffFileIdLoading(false);
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      const SOURCE_FILE_ID_LIST = responseJson?.data?.SOURCE_FILE_ID || [];
      const SORTED_SFF_FILE_ID =
        SOURCE_FILE_ID_LIST?.filter(
          (file_id) =>
            file_id !== null && file_id !== undefined && file_id !== "",
        )?.map((file_id) => ({
          label: file_id,
          value: file_id,
        })) ?? [];

      updateSourceInputs("current_category_data", SORTED_SFF_FILE_ID);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
      setIsSffFileIdLoading(false);
    } finally {
      setIsSffFileIdLoading(false);
    }
  };

  const handleCategoryChange = async (e, selectedOption) => {
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_category", selectedOption.value);
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
  };

  const handleRadioChange = async (event) => {
    updateSourceInputs("current_filter_value", event.target.value);
    clearState();

    const filter = event.target.value;
    await setMappedData(
      source_data?.current_dimension?.value,
      source_data.current_country,
      source_data.current_category,
      filter.toLowerCase(),
    );
  };

  const handlePlaceholderFile = async () => {
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", false);
  };

  const handleCheckboxAll = () => {
    updateSourceInputs(
      "get_recommendation_for_all_rows",
      !source_data.get_recommendation_for_all_rows,
    );
  };

  const checkCMUHasRecommendations = (cmu) => {
    const Available_CMU_List =
      source_data?.data?.dropdown?.ai_recommendations_cmu_list || [];
    if (!Available_CMU_List || Available_CMU_List.length === 0) return false;
    if (Available_CMU_List.includes(cmu)) return true;
    return false;
  };

  return (
    <>
      {!is_Approver && (
        <div className="cnc-toggle-icon">
          <label
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "Collapse" : "Expand"}
          </label>
          <i
            className="material-icons"
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "keyboard_arrow_up" : "keyboard_arrow_down"}
          </i>
        </div>
      )}

      {!expand && (
        <div className="cnc-model-header-mapping">
          <Grid container spacing={1} style={{ padding: "2px 15px 0px 15px" }}>
            {/* Select Dataset */}
            <Grid item xs={2} sm={2}>
              <div className="mg-model-header-item" style={{ height: "25px" }}>
                Select Dataset:{" "}
                <p
                  style={{
                    display: "inline",
                    color: "red",
                    fontSize: 16,
                  }}
                >
                  *
                </p>
              </div>
              <div className="" style={{ marginBottom: "15px" }}>
                <Autocomplete
                  id="country-select"
                  disableClearable
                  size="small"
                  options={source_data.current_mapped_source || []}
                  loading={
                    loading &&
                    (source_data.current_mapped_source ||
                      source_data.current_mapped_source.length === 0)
                  }
                  loadingText={<Loader />}
                  getOptionLabel={(option) => option.label}
                  onChange={handleSourceChange}
                  value={
                    source_data.current_source &&
                    source_data.current_source.length > 0
                      ? {
                          label: source_data.current_source,
                          value: source_data.current_source,
                        }
                      : null
                  }
                  popupIcon={
                    <span
                      className="material-icons"
                      style={{
                        fontSize: "20px",
                        color:
                          source_data.current_source === "" ? "f7f7f7" : "#555",
                      }}
                    >
                      arrow_drop_down
                    </span>
                  }
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#fff",
                      fontFamily: "Hind Siliguri",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "400",
                      color: "#333",
                      height: "36px",
                      paddingRight: "36px", // space for dropdown icon
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 12px",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)", // vertical center alignment
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#999",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      // label="Select Country"
                      InputLabelProps={{
                        style: {
                          fontSize: "13px",
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                        color: "#212529",
                      }}
                    >
                      {option.label}
                    </li>
                  )}
                />
              </div>
            </Grid>

            {/* Select Dimensions */}
            <Grid item xs={2} sm={2}>
              <div className="mg-model-header-item" style={{ height: "25px" }}>
                Select Dimensions:
                <p
                  style={{
                    display: "inline",
                    color: "red",
                    fontSize: 16,
                  }}
                >
                  *
                </p>
              </div>
              <div className="" style={{ marginBottom: "15px" }}>
                <Autocomplete
                  id="country-select"
                  disableClearable
                  size="small"
                  options={
                    source_data?.dimensions_list
                      ?.filter((dimension) => {
                        return (
                          dimension.dataset_name === source_data.current_source
                        );
                      })
                      ?.flatMap((item) => item.dimensions) || []
                  }
                  disabled={
                    !source_data.current_source ||
                    source_data.current_source.length === 0
                  }
                  loading={
                    loading &&
                    (source_data.dimensions_list ||
                      source_data.dimensions_list.length === 0)
                  }
                  loadingText={<Loader />}
                  getOptionLabel={(option) => option.label}
                  onChange={handleDimensionChange}
                  value={
                    source_data.current_dimension &&
                    Object.keys(source_data.current_dimension).length > 0
                      ? source_data.current_dimension
                      : null
                  }
                  popupIcon={
                    <span
                      className="material-icons"
                      style={{
                        fontSize: "20px",
                        color:
                          source_data.current_dimension === ""
                            ? "f7f7f7"
                            : "#555",
                      }}
                    >
                      arrow_drop_down
                    </span>
                  }
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor:
                        source_data.current_source === "" ? "#d6d6d6" : "#fff",
                      fontFamily: "Hind Siliguri",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "400",
                      color: "#333",
                      height: "36px",
                      paddingRight: "36px", // space for dropdown icon
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 12px",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)", // vertical center alignment
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#999",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      // label="Select Country"
                      InputLabelProps={{
                        style: {
                          fontSize: "13px",
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                        color: "#212529",
                      }}
                    >
                      {option.label}
                    </li>
                  )}
                />
              </div>
            </Grid>

            {/* Select Country */}
            <Grid item xs={3} sm={3}>
              <div className="mg-model-header-item" style={{ height: "25px" }}>
                Select Country:{" "}
                <p
                  style={{
                    display: "inline",
                    color: "red",
                    fontSize: 16,
                  }}
                >
                  *
                </p>
              </div>
              <div className="" style={{ marginBottom: "15px" }}>
                <Autocomplete
                  id="country-select"
                  disableClearable
                  size="small"
                  options={
                    source_data?.current_mapped_country?.filter(
                      (item) =>
                        // 1. Ensure it's a valid object
                        item &&
                        typeof item === "object" &&
                        Object.keys(item).length > 0 &&
                        // 2. Ensure label is valid
                        item.label !== null &&
                        item.label !== "null" &&
                        item.label !== undefined &&
                        item.label !== "" &&
                        // 3. Ensure name is valid
                        item.value !== null &&
                        item.value !== "null" &&
                        item.value !== undefined &&
                        item.value !== "",
                    ) || []
                  }
                  disabled={
                    !source_data.current_source ||
                    source_data.current_source.length === 0
                  }
                  loading={
                    loading ||
                    (isCountryLoading &&
                      (source_data.current_mapped_country ||
                        source_data.current_mapped_country.length === 0))
                  }
                  loadingText={<Loader />}
                  getOptionLabel={(option) => option.label}
                  onChange={handleCountryChange}
                  value={
                    source_data.current_country &&
                    source_data.current_country.length > 0
                      ? {
                          label: source_data.current_country,
                          value: source_data.current_country,
                        }
                      : null
                  }
                  popupIcon={
                    <span
                      className="material-icons"
                      style={{
                        fontSize: "20px",
                        color:
                          !source_data.current_dimension ||
                          Object.keys(source_data.current_dimension).length ===
                            0
                            ? "f7f7f7"
                            : "#555",
                      }}
                    >
                      arrow_drop_down
                    </span>
                  }
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor:
                        !source_data.current_dimension ||
                        Object.keys(source_data.current_dimension).length === 0
                          ? "#d6d6d6"
                          : "#fff",
                      fontFamily: "Hind Siliguri",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "400",
                      color: "#333",
                      height: "36px",
                      paddingRight: "36px", // space for dropdown icon
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 12px",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)", // vertical center alignment
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#999",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      // label="Select Country"
                      InputLabelProps={{
                        style: {
                          fontSize: "13px",
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                        color: "#212529",
                      }}
                    >
                      {option.label}
                    </li>
                  )}
                />
              </div>
            </Grid>

            {/* Select SFF_FILE_ID */}
            <Grid item xs={3} sm={3}>
              <div className="mg-model-header-item" style={{ height: "25px" }}>
                Select Sff File Id:{" "}
                <p
                  style={{
                    display: "inline",
                    color: "red",
                    fontSize: 16,
                  }}
                >
                  *
                </p>
              </div>
              <div className="" style={{ marginBottom: "15px" }}>
                <Autocomplete
                  id="country-select"
                  disableClearable
                  size="small"
                  disabled={
                    !source_data.current_country ||
                    source_data.current_country.length === 0
                  }
                  options={
                    source_data?.current_category_data?.filter(
                      (item) =>
                        // 1. Ensure it's a valid object
                        item &&
                        typeof item === "object" &&
                        Object.keys(item).length > 0 &&
                        // 2. Ensure label is valid
                        item.label !== null &&
                        item.label !== "null" &&
                        item.label !== undefined &&
                        item.label !== "" &&
                        // 3. Ensure name is valid
                        item.value !== null &&
                        item.value !== "null" &&
                        item.value !== undefined &&
                        item.value !== "",
                    ) || []
                  }
                  loading={
                    loading ||
                    (isSffFileIdLoading &&
                      (source_data.current_category_data ||
                        source_data.current_category_data.length === 0))
                  }
                  loadingText={<Loader />}
                  getOptionLabel={(option) => option.label}
                  onChange={handleCategoryChange}
                  value={
                    source_data.current_category &&
                    source_data.current_category.length > 0
                      ? {
                          label: source_data.current_category,
                          value: source_data.current_category,
                        }
                      : null
                  }
                  popupIcon={
                    <span
                      className="material-icons"
                      style={{
                        fontSize: "20px",
                        color:
                          source_data.current_country === ""
                            ? "f7f7f7"
                            : "#555",
                      }}
                    >
                      arrow_drop_down
                    </span>
                  }
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor:
                        source_data.current_country === "" ? "#d6d6d6" : "#fff",
                      fontFamily: "Hind Siliguri",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "400",
                      color: "#333",
                      height: "36px",
                      paddingRight: "36px", // space for dropdown icon
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 12px",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)", // vertical center alignment
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#999",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      // label="Select Country"
                      InputLabelProps={{
                        style: {
                          fontSize: "13px",
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                        color: "#212529",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      {option.label}
                      {checkCMUHasRecommendations(option.label) && (
                        <span
                          class="material-symbols-outlined"
                          style={{ color: "#eb367f", fontWeight: "400" }}
                        >
                          wand_stars
                        </span>
                      )}
                    </li>
                  )}
                />
              </div>
            </Grid>

            {/* Action Filters */}
            <Grid item xs={2} sm={2}>
              <div className="mg-model-header-item" style={{ height: "25px" }}>
                Choose Filter:{" "}
                <p
                  style={{
                    display: "inline",
                    color: "red",
                    fontSize: 16,
                  }}
                >
                  *
                </p>
              </div>
              <div
                className="radio-input-container"
                style={{ marginBottom: "15px" }}
              >
                <div className="radio-input-div">
                  <input
                    id="all-checkbox"
                    type="radio"
                    value="All"
                    disabled={isFilterAllVisible}
                    name="filter"
                    checked={source_data.current_filter_value === "All"}
                    onChange={handleRadioChange}
                    className="radio-checkbox-label"
                  />
                  <InputLabel
                    htmlFor={"all-checkbox"}
                    className="radio-checkbox-label"
                  >
                    All
                  </InputLabel>
                </div>

                <div className="radio-input-div">
                  <input
                    id="Unmapped-checkbox"
                    type="radio"
                    value="Unmapped"
                    disabled={isFilterUnmappedVisible}
                    name="filter"
                    checked={source_data.current_filter_value === "Unmapped"}
                    onChange={handleRadioChange}
                    className="radio-checkbox-label"
                  />
                  <InputLabel
                    htmlFor={"Unmapped-checkbox"}
                    className="radio-checkbox-label"
                  >
                    Unmapped
                  </InputLabel>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      )}

      {isPlaceholderFetching && <Loader />}

      {/* FILE UPLOAD OR PLACEHOLDER SELECTION */}
      {!expand &&
        !isPlaceholderFetching &&
        !isFileUploading &&
        source_data.is_initial &&
        source_data.is_table_loading &&
        has_Awaiting_Data && (
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            {source_data.current_filter_value !== "" && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "15px" }}
              >
                {source_data.data.dropdown.recommendation_details
                  ?.is_recommendation &&
                  source_data?.current_dimension &&
                  source_data?.data?.dropdown?.dimensions_with_approval &&
                  source_data?.data?.dropdown?.dimensions_with_approval?.includes(
                    source_data?.current_dimension?.value,
                  ) && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginRight: "30px",
                      }}
                    >
                      <input
                        type="checkbox"
                        style={{ height: "14px", width: "14px" }}
                        onChange={handleCheckboxAll}
                        checked={source_data.get_recommendation_for_all_rows}
                      />
                      <span>Get Recommendations</span>
                    </div>
                  )}
                <div>
                  <GlobalDropZone
                    updateAlert={updateAlert}
                    handleFileUpload={props.handleFileUpload}
                    requiredColumns={
                      source_data?.data?.dropdown?.download_sample_columns || []
                    }
                  />

                  <FileUpload
                    updateAlert={updateAlert}
                    handleFileUpload={props.handleFileUpload}
                    isFileUploading={props.isFileUploading}
                    requiredColumns={
                      source_data?.data?.dropdown?.download_sample_columns || []
                    }
                    source_Data={source_data}
                    updateSourceInputs={updateSourceInputs}
                    user={user}
                  />
                </div>
                <span>Or</span>
                <button
                  onClick={handlePlaceholderFile}
                  className="sample-button"
                  // disabled={source_data.is_table_loading}
                >
                  Proceed with Existing Template
                </button>
              </div>
            )}
          </div>
        )}
    </>
  );
}

MetaSearchFilters.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  source_data: PropTypes.object,
  cncData: PropTypes.object,
  brand_data: PropTypes.object,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  cncData: state.cncinputs,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateSourceInputs,
  updateAlert,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetaSearchFilters),
);
